/* eslint-disable react/jsx-props-no-spreading */
/**
 * @description This renders the navigation bar that appears at the top of the application
 */

import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

import ErrorBoundary from '@seccon/shared/ui/components/ErrorBoundary';

import NavDropdown from './NavDropdown';
import NavLink from './NavLink';
import NavUserMenu from './NavUserMenu';
import useNavigationLinks from '../hooks/useNavigationLinks';
import logo from '../resources/sc_logo_hz_web_ondarkbg.png';

const styles = {
  appBar: {
    flexWrap: 'nowrap',
    minHeight: '4.5rem',
    width: '100%'
  },
  logo: {
    height: '3.125rem',
    width: '17.1875rem'
  },
  logoLink: {
    display: 'flex'
  },
  navigationLinkList: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    gap: 3,
    paddingX: 4,
    paddingY: 1
  },
  toolbar: {
    flex: 1
  }
};

const NavBar = () => {
  // Retrieve the list of navigation links
  const navigationLinks = useNavigationLinks();

  return (
    <AppBar sx={styles.appBar} position='static'>
      <Toolbar sx={styles.toolbar}>
        <Link href='/' reloadDocument sx={styles.logoLink}>
          <Box component='img' sx={styles.logo} alt='Security Control Logo' src={logo} />
        </Link>
        <Box sx={styles.navigationLinkList}>
          {navigationLinks.map((entry) => (entry.isDropdown ? (
            <ErrorBoundary key={entry.label}>
              <NavDropdown {...entry} />
            </ErrorBoundary>
          ) : (
            <ErrorBoundary key={entry.label}>
              <NavLink {...entry} />
            </ErrorBoundary>
          )))}
        </Box>
        <ErrorBoundary>
          <NavUserMenu />
        </ErrorBoundary>
      </Toolbar>
    </AppBar>
  );
};

export default NavBar;
